<div class="view-header flex-header">
  <div class="view-header-left">
    <h1 class="view-title">Candidate Management</h1>
    <p class="view-subtitle">{{ totalCandidatesCount }} total candidates</p>
  </div>
   <ng-container *hasPermission="[PermissionForStudents.CANDIDATE_VIEW_FRESHER,
    PermissionForStudents.CANDIDATE_VIEW_EXPERIENCED,
    PermissionForStudents.CANDIDATE_VIEW_EDUCATOR]">
  <button class="primary-btn" (click)="openAddPopup()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
    Add Candidates
  </button>
  </ng-container>
</div>

<!-- KPI Cards Row -->
<div class="kpi-cards-row">
  <div class="kpi-card total">
    <div class="kpi-icon-wrapper purple-bg">
      <svg
        class="kpi-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    </div>
    <div class="kpi-content">
      <span class="kpi-lbl">TOTAL CANDIDATES</span>
      <span class="kpi-val">{{ totalCandidatesCount }}</span>
    </div>
  </div>

  <div class="kpi-card selected">
    <div class="kpi-icon-wrapper green-bg">
      <svg
        class="kpi-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <polyline points="16 11 18 13 22 9" />
      </svg>
    </div>
    <div class="kpi-content">
      <span class="kpi-lbl">SELECTED</span>
      <span class="kpi-val">{{ selectedCandidatesCount }}</span>
    </div>
  </div>

  <div class="kpi-card on-hold">
    <div class="kpi-icon-wrapper orange-bg">
      <svg
        class="kpi-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    </div>
    <div class="kpi-content">
      <span class="kpi-lbl">ON HOLD</span>
      <span class="kpi-val">{{ onHoldCandidatesCount }}</span>
    </div>
  </div>

  <div class="kpi-card rejected">
    <div class="kpi-icon-wrapper red-bg">
      <svg
        class="kpi-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <line x1="17" y1="11" x2="22" y2="16" />
        <line x1="22" y1="11" x2="17" y2="16" />
      </svg>
    </div>
    <div class="kpi-content">
      <span class="kpi-lbl">REJECTED</span>
      <span class="kpi-val">{{ rejectedCandidatesCount }}</span>
    </div>
  </div>
</div>

<!-- Inner Experience tabs -->
  <ng-container *hasPermission="[PermissionForStudents.CANDIDATE_VIEW_FRESHER,
  PermissionForStudents.CANDIDATE_VIEW_EXPERIENCED,
  PermissionForStudents.CANDIDATE_VIEW_EDUCATOR]">
<div class="sub-tabs-container">
  <div class="tabs-left">
    <ng-container *hasPermission="PermissionForStudents.CANDIDATE_VIEW_FRESHER">
    <button
      class="sub-tab-btn"
      [class.active]="candidateTab === 'fresher'"
      (click)="switchTab('fresher')"
    >
      Fresher
    </button>
    </ng-container>
    <ng-container *hasPermission="PermissionForStudents.CANDIDATE_VIEW_EXPERIENCED">
    <button
      class="sub-tab-btn"
      [class.active]="candidateTab === 'experienced'"
      (click)="switchTab('experienced')"
    >
      Experienced
    </button>
    </ng-container>
    <ng-container *hasPermission="PermissionForStudents.CANDIDATE_VIEW_EDUCATOR">
    <button
      class="sub-tab-btn"
      [class.active]="candidateTab === 'educator'"
      (click)="switchTab('educator')"
    >
      Candidates
    </button>
    </ng-container>
  </div>
  <ng-container *hasPermission="[PermissionForStudents.CANDIDATE_VIEW_FRESHER,
   PermissionForStudents.CANDIDATE_VIEW_EXPERIENCED, PermissionForStudents.CANDIDATE_VIEW_EDUCATOR]">
  <button class="download-btn" (click)="downloadUserData()">
    <i class="bi bi-download me-1"></i>
    Download Excel
  </button>
  </ng-container>
</div>
</ng-container>

<!-- Filter bar -->
 <ng-container *hasPermission="[PermissionForStudents.CANDIDATE_VIEW_FRESHER,
  PermissionForStudents.CANDIDATE_VIEW_EXPERIENCED,
  PermissionForStudents.CANDIDATE_VIEW_EDUCATOR]">
<div class="filters-bar">
  <div class="search-input-group">
    <svg
      class="search-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
    <input
      type="text"
      placeholder="Search candidates..."
      [(ngModel)]="candidateSearchQuery"
      (ngModelChange)="onSearchChange()"
    />
    <button
      *ngIf="candidateSearchQuery"
      class="clear-icon"
      (click)="candidateSearchQuery = ''; onSearchChange()"
      title="Clear search"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>

    <div class="search-filter-row">
    <div class="job-filter">
        <div class="job-filter-input" (click)="toggleCandidateJobDropdown($event)">
          <span
            [matTooltip]="candidateFilters.job_title || 'Select Job Title'"
            matTooltipPosition="above">
            {{ candidateFilters.job_title || 'Select Job Title' }}
          </span>
          <i
            *ngIf="candidateFilters.job_title; else dropdownIcon"
            class="bi bi-x-lg clear-icon"
            (click)="clearCandidateJob($event)">
          </i>

          <ng-template #dropdownIcon>
            <i class="bi"
              [ngClass]="showCandidateJobDropdown ? 'bi-chevron-up' : 'bi-chevron-down'">
            </i>
          </ng-template>
        </div>
      
      <div class="job-dropdown" *ngIf="showCandidateJobDropdown">
        <div class="dropdown-body">
          <div
            class="job-option"
            *ngFor="let job of allPostJobs"
            (click)="selectCandidateJob(job)">
            <span [matTooltip]="job.job_title" matTooltipPosition="above">{{ job.job_title || 'N/A' }}</span>
          </div>
          <div
            class="no-jobs"
            *ngIf="!allPostJobs.length && !isJobLoading">
            No jobs found
          </div>
        </div>
        <div class="dropdown-pagination" *ngIf="totalPage > 1">
          <button
            type="button"
            (click)="previousJobPage($event)"
            [disabled]="page === 1">
            Previous
          </button>
          <span>{{ page }} / {{ totalPage }}</span>
          <button
            type="button"
            (click)="nextJobPage($event)"
            [disabled]="page === totalPage">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="dropdowns-group">
    

    
    
    

    
    <div class="custom-dropdown-container">
      <button class="custom-dropdown-toggle-btn" (click)="toggleFinalStatusDropdown($event)">
        <span class="btn-text-content">{{
          candidateFilters.final_status || "All Status"
        }}</span>
        <svg
          class="dropdown-chevron"
          [class.rotated]="isFinalStatusDropdownOpen"
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="m6 9 6 6 6-6" />
        </svg>
      </button>

      <div
        class="custom-dropdown-menu"
        *ngIf="isFinalStatusDropdownOpen"
        (click)="$event.stopPropagation()"
      >
        <div
          class="menu-option-item"
          [class.selected]="!candidateFilters.final_status"
          (click)="selectFinalStatus('')"
        >
          <svg class="check-icon" *ngIf="!candidateFilters.final_status" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
          All Status
        </div>
        <div
          class="menu-option-item"
          [class.selected]="candidateFilters.final_status === 'Selected'"
          (click)="selectFinalStatus('Selected')"
        >
          <svg class="check-icon" *ngIf="candidateFilters.final_status === 'Selected'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
          Selected
        </div>
        <div
          class="menu-option-item"
          [class.selected]="candidateFilters.final_status === 'On Hold'"
          (click)="selectFinalStatus('On Hold')"
        >
          <svg class="check-icon" *ngIf="candidateFilters.final_status === 'On Hold'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
          On Hold
        </div>
        <div
          class="menu-option-item"
          [class.selected]="candidateFilters.final_status === 'Rejected'"
          (click)="selectFinalStatus('Rejected')"
        >
          <svg class="check-icon" *ngIf="candidateFilters.final_status === 'Rejected'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
          Rejected
        </div>
      </div>
    </div>

    <button
      class="custom-dropdown-toggle-btn"
      (click)="showAdvancedFilters = true"
    >
      Filters
      <i class="bi bi-sliders"></i>
    </button>

    <div
      class="filter-backdrop"
      *ngIf="showAdvancedFilters"
      (click)="showAdvancedFilters = false"
    ></div>

    <div class="filter-modal" *ngIf="showAdvancedFilters">
      <div class="filter-modal-header">
        <h4>Advanced Filters</h4>
        <button class="close-btn" (click)="showAdvancedFilters = false">
          ✕
        </button>
      </div>

      <div class="filter-field">
        <label>City</label>
        <input
          type="text"
          placeholder="Enter city"
          [(ngModel)]="candidateFilters.city"
          (ngModelChange)="onCityChange($event)"
        />
        <small class="text-danger" *ngIf="validateCity(candidateFilters.city)">
          {{ validateCity(candidateFilters.city) }}
        </small>
      </div>

      <div class="filter-field">
        <label>Experience (Years)</label>
        <div class="range-row">
          <input
            type="number"
            placeholder="Min"
            [(ngModel)]="candidateFilters.min_exp"
          />

          <input
            type="number"
            placeholder="Max"
            [(ngModel)]="candidateFilters.max_exp"
          />
        </div>
        <small
          class="smaller-text text-danger"
          *ngIf="
            validateRange(
              candidateFilters.min_exp,
              candidateFilters.max_exp,
              50,
              'experience'
            )
          "
        >
          {{
            validateRange(
              candidateFilters.min_exp,
              candidateFilters.max_exp,
              50,
              "experience"
            )
          }}
        </small>
      </div>

      <div class="filter-field">
        <label>Assessment Score (%)</label>
        <div class="range-row">
          <input
            type="number"
            placeholder="Min"
            [(ngModel)]="candidateFilters.min_assessment_score"
          />

          <input
            type="number"
            placeholder="Max"
            [(ngModel)]="candidateFilters.max_assessment_score"
          />
        </div>
        <small
          class="smaller-text text-danger"
          *ngIf="
            validateRange(
              candidateFilters.min_assessment_score,
              candidateFilters.max_assessment_score,
              100,
              'assessment score'
            )
          "
        >
          {{
            validateRange(
              candidateFilters.min_assessment_score,
              candidateFilters.max_assessment_score,
              100,
              "assessment score"
            )
          }}
        </small>
      </div>

      <div class="filter-field">
        <label>AI Interview Score (%)</label>
        <div class="range-row">
          <input
            type="number"
            placeholder="Min"
            [(ngModel)]="candidateFilters.min_ai_score"
          />

          <input
            type="number"
            placeholder="Max"
            [(ngModel)]="candidateFilters.max_ai_score"
          />
        </div>
        <small
          class="smaller-text text-danger"
          *ngIf="
            validateRange(
              candidateFilters.min_ai_score,
              candidateFilters.max_ai_score,
              100,
              'AI interview score'
            )
          "
        >
          {{
            validateRange(
              candidateFilters.min_ai_score,
              candidateFilters.max_ai_score,
              100,
              "AI interview score"
            )
          }}
        </small>
      </div>

      <div class="filter-field">
        <label>Current CTC (LPA)</label>
        <div class="range-row">
          <input
            type="number"
            placeholder="Min"
            [(ngModel)]="candidateFilters.min_current_ctc"
          />

          <input
            type="number"
            placeholder="Max"
            [(ngModel)]="candidateFilters.max_current_ctc"
          />
        </div>
        <small
          class="smaller-text text-danger"
          *ngIf="
            validateRange(
              candidateFilters.min_current_ctc,
              candidateFilters.max_current_ctc,
              100,
              'current CTC'
            )
          "
        >
          {{
            validateRange(
              candidateFilters.min_current_ctc,
              candidateFilters.max_current_ctc,
              100,
              "current CTC"
            )
          }}
        </small>
      </div>

      <div class="filter-field">
        <label>Expected CTC (LPA)</label>
        <div class="range-row">
          <input
            type="number"
            placeholder="Min"
            [(ngModel)]="candidateFilters.min_expected_ctc"
          />

          <input
            type="number"
            placeholder="Max"
            [(ngModel)]="candidateFilters.max_expected_ctc"
          />
        </div>
        <small
          class="smaller-text text-danger"
          *ngIf="
            validateRange(
              candidateFilters.min_expected_ctc,
              candidateFilters.max_expected_ctc,
              100,
              'expected CTC'
            )
          "
        >
          {{
            validateRange(
              candidateFilters.min_expected_ctc,
              candidateFilters.max_expected_ctc,
              100,
              "expected CTC"
            )
          }}
        </small>
      </div>

      <!-- SKILL 
      <div class="filter-field">
        <label>Skill</label>
        <input
          type="text"
          placeholder="Angular, React, Java..."
          [(ngModel)]="candidateFilters.skill"
        />
      </div>
      <div class="filter-field">
        <label>Subject</label>
        <input
          type="text"
          placeholder="Mathematics, Science..."
          [(ngModel)]="candidateFilters.subject"
        />
      </div> will used this later-->

      <div class="filter-actions">
        <button class="btn-outline" (click)="clearFilters()">Clear</button>

        <button
          class="btn-add"
          (click)="applyFilters(); showAdvancedFilters = false"
          [disabled]="hasValidationErrors()"
        >
          Apply Filters
        </button>
      </div>
    </div>
  </div>
</div>
</ng-container>

<!-- Candidates Table Card -->
<div class="grid-card">
  <div class="table-container scrollable-table">
    <!-- FRESHER TABLE VIEW -->
    <table class="data-table" *ngIf="candidateTab === 'fresher'">
      <thead>
        <tr>
          <th>S.no</th>
          <th>Candidate</th>
          <th>Mobile Number</th>
          <th>Role</th>
          <th>Job Title</th>
          <th>Education</th>
          <th>College Name</th>
          <th>Year of Passing</th>
          <th>Current Location</th>
          <th class="center-align">Resume</th>
          <th class="center-align">Latest Assessment</th>
          <th class="center-align">Latest AI Interview</th>
          <th>Applied On</th>
          <th>Final Status</th>
          <th class="center-align">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="isLoading">
          <td colspan="14" class="empty-state-cell">Loading candidates...</td>
        </tr>
        <ng-container *ngIf="!isLoading">
        <tr *ngFor="let candidate of filteredCandidates; let i = index">
          <td>{{ (currentPage - 1) * limit + i + 1 }}</td>
          <td>
            <div class="candidate-meta-cell">
              <span class="candidate-name expertise-texts" [matTooltip]="candidate.name">{{ candidate.name || "-" }}</span>
              <span class="candidate-email expertise-texts" [matTooltip]="candidate.email">{{ candidate.email || "-" }}</span>
            </div>
          </td>
          <td>{{ candidate.mobile }}</td>
          <td class="font-semibold">
            <span [matTooltip]="candidate.role" class="expertise-text">
            {{ candidate.role || "-" }}
          </span>
        </td>
          <td class="font-semibold">
          <span [matTooltip]="candidate.job_title" class="expertise-text">
            {{ candidate.job_title || "-" }}</span></td>
          <td>
            <span [matTooltip]="candidate.education" class="expertise-text">
            {{ candidate.education || "-" }}</span>
          </td>
          <td [title]="candidate.previousInstitute || ''">
            {{
              candidate.previousInstitute &&
              candidate.previousInstitute.length > 15
                ? (candidate.previousInstitute | slice: 0 : 15) + "..."
                : candidate.previousInstitute || "-"
            }}
          </td>
          <td>{{ candidate.yearOfPassing || "-" }}</td>
          <td>
          <span [matTooltip]="candidate.location" class="expertise-text">
            {{ candidate.location || "-" }}
          </span>
          </td>
          <td class="center-align">
            <button
              *ngIf="candidate.resume_url; else noResume"
              class="icon-btn-resume"
              title="Download Resume"
              (click)="downloadResume(candidate.resume_url)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="file-text-icon"
              >
                <path
                  d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                />
                <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                <path d="M10 9H8" />
                <path d="M16 13H8" />
                <path d="M16 17H8" />
              </svg>
              <span class="btn-lbl-txt">Resume</span>
            </button>
            <ng-template #noResume>
              <button
                class="icon-btn-resume"
                title="No Resume Uploaded"
                disabled
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="file-text-icon"
                >
                  <path
                    d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                  />
                  <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                  <line x1="9" y1="15" x2="15" y2="15" />
                </svg>
                <span class="btn-lbl-txt">Not Uploaded</span>
              </button>
            </ng-template>
          </td>
          <td class="center-align">
            <span
              class="score-badge"
              [ngClass]="getScoreColorClass(candidate.assessmentScore)"
            >
              {{ candidate.assessmentScore }}%
            </span>
          </td>
          <td class="center-align">
            <span
              class="score-badge"
              [ngClass]="getScoreColorClass(candidate.interviewScore)"
            >
              {{ candidate.interviewScore }}%
            </span>
          </td>
          <td>{{ candidate.appliedDate || "-" }}</td>
          <td>
            <span class="status-pill" [ngClass]="{
              'pill-selected': candidate.final_status === 'selected',
              'pill-closed': candidate.final_status === 'rejected',
              'pill-interview': candidate.final_status === 'on_hold',
              'pill-applied': !candidate.final_status || candidate.final_status === 'not_updated'
            }">
              {{ (candidate.final_status === 'on_hold' ? 'On Hold' : 
                 (candidate.final_status === 'selected' ? 'Selected' : 
                 (candidate.final_status === 'rejected' ? 'Rejected' : 'Not Updated'))) }}
            </span>
          </td>
          <td class="center-align action-cell">
            <button
              class="icon-btn"
              title="View Profile"
              (click)="viewCandidate(candidate.id)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </button>

            <button
              class="icon-btn"
              title="Edit Candidate"
              (click)="editCandidate(candidate)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M12 20h9" />
                <path
                  d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"
                />
              </svg>
            </button>

            <button
              [disabled]="isCandidateDelete === candidate.id"
              class="icon-btn danger"
              title="Delete Candidate"
              (click)="openDeleteConfirm(candidate.id)"
            >
              <span
                *ngIf="isCandidateDelete === candidate.id"
                class="spinner-border spinner-border-sm"
              ></span>

              <svg
                *ngIf="isCandidateDelete !== candidate.id"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                <path d="M10 11v6"></path>
                <path d="M14 11v6"></path>
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 2 0 0 1 1 1v2"></path>
              </svg>
            </button>
          </td>
        </tr>
        </ng-container>
        <tr *ngIf="!isLoading && filteredCandidates.length === 0">
          <td colspan="14" class="empty-state-cell">
            No candidates match the selected filters.
          </td>
        </tr>
      </tbody>
    </table>

    <!-- EXPERIENCED TABLE VIEW -->
    <table class="data-table" *ngIf="candidateTab === 'experienced'">
      <thead>
        <tr>
          <th>S.no</th>
          <th>Candidate</th>
          <th>Mobile Number</th>
          <th>Job Title</th>
          <th>Role (Job Role Category)</th>
          <th>Education</th>
          <th>College Name</th>
          <th>Year of Passing</th>
          <th>Current Job Title</th>
          <th>Current/Last Company</th>
          <th>Total Experience</th>
          <th>Core Expertise</th>
          <th>Current CTC</th>
          <th>Expected CTC</th>
          <th>Current Location</th>
          <th>Preferred City 1</th>
          <th>Preferred City 2</th>
          <th>Preferred City 3</th>
          <th class="center-align">Resume</th>
          <th class="center-align">Latest Assessment</th>
          <th class="center-align">Latest AI Interview</th>
          <th>Applied On</th>
          <th>Final Status</th>
          <th class="center-align">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="isLoading">
          <td colspan="23" class="empty-state-cell">Loading candidates...</td>
        </tr>
          <ng-container *ngIf="!isLoading">
        <tr *ngFor="let candidate of filteredCandidates; let i = index">
          <td>{{ (currentPage - 1) * limit + i + 1 }}</td>
          <td>
            <div class="candidate-meta-cell">
              <span class="candidate-name expertise-texts" [matTooltip]="candidate.name">{{ candidate.name || "-" }}</span>
              <span class="candidate-email expertise-texts" [matTooltip]="candidate.email">{{ candidate.email || "-" }}</span>
            </div>
          </td>
          <td>{{ candidate.mobile || "-" }}</td>
          <td class="font-semibold">
          <span [matTooltip]="candidate.job_title" class="expertise-text">
            {{ candidate.job_title || "-" }}
          </span>
          </td>
          <td class="font-semibold">
          <span [matTooltip]="candidate.role" class="expertise-text">
            {{ candidate.role || "-" }}
          </span>
        </td>
          <td>
            <span [matTooltip]="candidate.education" class="expertise-text">
            {{ candidate.education || "-" }}
          </span>
        </td>
          <td [title]="candidate.previousInstitute || ''">
            {{
              candidate.previousInstitute &&
              candidate.previousInstitute.length > 15
                ? (candidate.previousInstitute | slice: 0 : 15) + "..."
                : candidate.previousInstitute || "-"
            }}
          </td>
          <td>{{ candidate.yearOfPassing || "-" }}</td>
          <td>
          <span [matTooltip]="candidate.currentTitle" class="expertise-text">
            {{ candidate.currentTitle || "—" }}
          </span>
          </td>
          <td>
            <span [matTooltip]="candidate.currentCompany" class="expertise-text">
            {{ candidate.currentCompany || "—" }}
          </span>
         </td>
          <td>{{ candidate.experience || "—" }}</td>
          <td>
            <span [matTooltip]="candidate.core_expertise" class="expertise-text">
            {{ candidate.core_expertise || "—" }}</span>
          </td>
          <td>{{ candidate.currentCtc ? "₹" + candidate.currentCtc : "—" }}</td>
          <td>
            {{ candidate.expectedCtc ? "₹" + candidate.expectedCtc : "—" }}
          </td>
          <td>
            <span [matTooltip]="candidate.location" class="expertise-text">
            {{ candidate.location || "-" }}</span>
          </td>
          <td [title]="candidate.prefCity1 || ''">
            {{
              candidate.prefCity1 && candidate.prefCity1.length > 10
                ? (candidate.prefCity1 | slice: 0 : 10) + "..."
                : candidate.prefCity1 || "—"
            }}
          </td>
          <td [title]="candidate.prefCity2 || ''">
            {{
              candidate.prefCity2 && candidate.prefCity2.length > 10
                ? (candidate.prefCity2 | slice: 0 : 10) + "..."
                : candidate.prefCity2 || "—"
            }}
          </td>
          <td [title]="candidate.prefCity3 || ''">
            {{
              candidate.prefCity3 && candidate.prefCity3.length > 10
                ? (candidate.prefCity3 | slice: 0 : 10) + "..."
                : candidate.prefCity3 || "—"
            }}
          </td>
          <td class="center-align">
            <button
              *ngIf="candidate.resume_url; else noResume"
              class="icon-btn-resume"
              title="Download Resume"
              (click)="downloadResume(candidate.resume_url)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="file-text-icon"
              >
                <path
                  d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                />
                <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                <path d="M10 9H8" />
                <path d="M16 13H8" />
                <path d="M16 17H8" />
              </svg>
              <span class="btn-lbl-txt">Resume</span>
            </button>
            <ng-template #noResume>
              <button
                class="icon-btn-resume"
                title="No Resume Uploaded"
                disabled
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="file-text-icon"
                >
                  <path
                    d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                  />
                  <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                  <line x1="9" y1="15" x2="15" y2="15" />
                </svg>
                <span class="btn-lbl-txt">Not Uploaded</span>
              </button>
            </ng-template>
          </td>
          <td class="center-align">
            <span
              class="score-badge"
              [ngClass]="getScoreColorClass(candidate.assessmentScore)"
            >
              {{ candidate.assessmentScore }}%
            </span>
          </td>
          <td class="center-align">
            <span
              class="score-badge"
              [ngClass]="getScoreColorClass(candidate.interviewScore)"
            >
              {{ candidate.interviewScore }}%
            </span>
          </td>
          <td>{{ candidate.appliedDate }}</td>
          <td>
            <span class="status-pill" [ngClass]="{
              'pill-selected': candidate.final_status === 'selected',
              'pill-closed': candidate.final_status === 'rejected',
              'pill-interview': candidate.final_status === 'on_hold',
              'pill-applied': !candidate.final_status || candidate.final_status === 'not_updated'
            }">
              {{ (candidate.final_status === 'on_hold' ? 'On Hold' : 
                 (candidate.final_status === 'selected' ? 'Selected' : 
                 (candidate.final_status === 'rejected' ? 'Rejected' : 'Not Updated'))) }}
            </span>
          </td>
          <td class="center-align action-cell">
            <button
              class="icon-btn"
              title="View Profile"
              (click)="viewCandidate(candidate.id)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </button>

            <button
              class="icon-btn"
              title="Edit Candidate"
              (click)="editCandidate(candidate)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M12 20h9" />
                <path
                  d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"
                />
              </svg>
            </button>

            <button
              [disabled]="isCandidateDelete === candidate.id"
              class="icon-btn danger"
              title="Delete Candidate"
              (click)="openDeleteConfirm(candidate.id)"
            >
              <span
                *ngIf="isCandidateDelete === candidate.id"
                class="spinner-border spinner-border-sm"
              ></span>

              <svg
                *ngIf="isCandidateDelete !== candidate.id"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                <path d="M10 11v6"></path>
                <path d="M14 11v6"></path>
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 2 0 0 1 1 1v2"></path>
              </svg>
            </button>
          </td>
        </tr>
        </ng-container>
        <tr *ngIf="!isLoading && filteredCandidates.length === 0">
          <td colspan="23" class="empty-state-cell">
            No candidates match the selected filters.
          </td>
        </tr>
      </tbody>
    </table>

    <!-- EDUCATOR TABLE VIEW -->
    <table class="data-table" *ngIf="candidateTab === 'educator'">
      <thead>
        <tr>
          <th>S.no</th>
          
          <th>Email</th>
          <th class="center-align">Resume</th>
          <th>Candidate Name</th>
          <th>Job</th>
          <th>Mobile</th>
          <th>Subject</th>
          <th>Goal</th>
          <th>Exp (yrs)</th>
          <th>Current CTC (L)</th>
          <th>Expected CTC (L)</th>
          <th>Previous Institute</th>
          <th>City 1</th>
          <th>City 2</th>
          <th>City 3</th>
          <th class="center-align">Latest Assessment Score</th>
          <th class="center-align">Latest AI Interview Score</th>
          <!--<th>Status</th>-->
          <th>Applied On</th>
          <th>Final Status</th>
          <th class="center-align">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="isLoading">
          <td colspan="18" class="empty-state-cell">Loading candidates...</td>
        </tr>
          <ng-container *ngIf="!isLoading">
        <tr *ngFor="let candidate of filteredCandidates; let i = index">
          <td>{{ (currentPage - 1) * limit + i + 1 }}</td>
          
          <td>
            <div class="candidate-meta-cell">
              <span class="candidate-email expertise-texts" [matTooltip]="candidate.email">{{ candidate.email }}</span>
            </div>
          </td>
          <td class="center-align">
            <button
              *ngIf="candidate.resume_url; else noResume"
              class="icon-btn-resume"
              title="Download Resume"
              (click)="downloadResume(candidate.resume_url)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="file-text-icon"
              >
                <path
                  d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                />
                <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                <path d="M10 9H8" />
                <path d="M16 13H8" />
                <path d="M16 17H8" />
              </svg>
              <span class="btn-lbl-txt">Resume</span>
            </button>
            <ng-template #noResume>
              <button
                class="icon-btn-resume"
                title="No Resume Uploaded"
                disabled
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="file-text-icon"
                >
                  <path
                    d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                  />
                  <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                  <line x1="9" y1="15" x2="15" y2="15" />
                </svg>
                <span class="btn-lbl-txt">Not Uploaded</span>
              </button>
            </ng-template>
          </td>
          <td class="font-semibold" [title]="candidate.name || ''">
            {{
              candidate.name && candidate.name.length > 10
                ? (candidate.name | slice: 0 : 10) + "..."
                : candidate.name || "—"
            }}
          </td>
          <td>
          <span [matTooltip]="candidate.job_title" class="expertise-text">
            {{ candidate.job_title || "—" }}
          </span>
          </td>
          <td>{{ candidate.mobile }}</td>
          <td class="font-semibold" [title]="candidate.subject || ''">
            {{
              candidate.subject && candidate.subject.length > 10
                ? (candidate.subject | slice: 0 : 10) + "..."
                : candidate.subject || "—"
            }}
          </td>
          <td [title]="candidate.specialization || ''">
            {{
              candidate.specialization && candidate.specialization.length > 10
                ? (candidate.specialization | slice: 0 : 10) + "..."
                : candidate.specialization || "—"
            }}
          </td>
          <td>{{ candidate.experience || "—" }}</td>
          <td>
            {{ candidate.currentCtc ? candidate.currentCtc + " LPA" : "—" }}
          </td>
          <td class="font-semibold">
            {{ candidate.expectedCtc ? candidate.expectedCtc + " LPA" : "—" }}
          </td>
          <td [title]="candidate.previousInstitute || ''">
            {{
              candidate.previousInstitute &&
              candidate.previousInstitute.length > 10
                ? (candidate.previousInstitute | slice: 0 : 10) + "..."
                : candidate.previousInstitute || "—"
            }}
          </td>
          <td [title]="candidate.prefCity1 || ''">
            {{
              candidate.prefCity1 && candidate.prefCity1.length > 10
                ? (candidate.prefCity1 | slice: 0 : 10) + "..."
                : candidate.prefCity1 || "—"
            }}
          </td>
          <td [title]="candidate.prefCity2 || ''">
            {{
              candidate.prefCity2 && candidate.prefCity2.length > 10
                ? (candidate.prefCity2 | slice: 0 : 10) + "..."
                : candidate.prefCity2 || "—"
            }}
          </td>
          <td [title]="candidate.prefCity3 || ''">
            {{
              candidate.prefCity3 && candidate.prefCity3.length > 10
                ? (candidate.prefCity3 | slice: 0 : 10) + "..."
                : candidate.prefCity3 || "—"
            }}
          </td>
          <td class="center-align">
            <span
              class="score-badge"
              [ngClass]="getScoreColorClass(candidate.assessmentScore)"
            >
              {{ candidate.assessmentScore }}%
            </span>
          </td>
          <td class="center-align">
            <span
              class="score-badge"
              [ngClass]="getScoreColorClass(candidate.interviewScore)"
            >
              {{ candidate.interviewScore }}%
            </span>
          </td>
          <!--<td>
            <span class="status-pill" [ngClass]="{
                'pill-active': candidate.status === 'shortlisted',
                'pill-selected': candidate.status === 'selected',
                'pill-applied': candidate.status === 'applied',
                'pill-interview': candidate.status === 'interview_scheduled',
                'pill-closed': candidate.status === 'rejected',
                'pill-new': candidate.status === 'new',
                'pill-assessment_pending':
                  candidate.status === 'assessment_pending',
                'pill-assessment_completed':
                  candidate.status === 'assessment_completed',
                'pill-ai_interview_pending':
                  candidate.status === 'ai_interview_pending',
              }"
            >
              {{ statusLabels[candidate.status] }}
            </span>
          </td>-->
          <td>{{ candidate.appliedDate }}</td>
          <td>
            <span class="status-pill" [ngClass]="{
              'pill-selected': candidate.final_status === 'selected',
              'pill-closed': candidate.final_status === 'rejected',
              'pill-interview': candidate.final_status === 'on_hold',
              'pill-applied': !candidate.final_status || candidate.final_status === 'not_updated'
            }">
              {{ (candidate.final_status === 'on_hold' ? 'On Hold' : 
                 (candidate.final_status === 'selected' ? 'Selected' : 
                 (candidate.final_status === 'rejected' ? 'Rejected' : 'Not Updated'))) }}
            </span>
          </td>
          <td class="center-align action-cell">
            <button
              class="icon-btn"
              title="View Profile"
              (click)="viewCandidate(candidate.id)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </button>

            <button
              class="icon-btn"
              title="Edit Candidate"
              (click)="editCandidate(candidate)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M12 20h9" />
                <path
                  d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"
                />
              </svg>
            </button>

            <button
              [disabled]="isCandidateDelete === candidate.id"
              class="icon-btn danger"
              title="Delete Candidate"
              (click)="openDeleteConfirm(candidate.id)"
            >
              <span
                *ngIf="isCandidateDelete === candidate.id"
                class="spinner-border spinner-border-sm"
              ></span>

              <svg
                *ngIf="isCandidateDelete !== candidate.id"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                <path d="M10 11v6"></path>
                <path d="M14 11v6"></path>
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 2 0 0 1 1 1v2"></path>
              </svg>
            </button>
          </td>
          <!-- <td>
            <span class="status-pill" [ngClass]="{
              'pill-selected': candidate.final_status === 'selected',
              'pill-closed': candidate.final_status === 'rejected',
              'pill-interview': candidate.final_status === 'on_hold',
              'pill-applied': !candidate.final_status || candidate.final_status === 'not_updated'
            }">
              {{ (candidate.final_status === 'on_hold' ? 'On Hold' : 
                 (candidate.final_status === 'selected' ? 'Selected' : 
                 (candidate.final_status === 'rejected' ? 'Rejected' : 'Not Updated'))) }}
            </span>
          </td> <td class="center-align action-cell">
             <button class="action-menu-item" (click)="closeActionMenu()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                  />
                  <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                  <path d="m9 15 2 2 4-4" />
                </svg>
                Assign Assessment
              </button>
              <button class="action-menu-item" (click)="closeActionMenu()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="2" y="3" width="20" height="14" rx="2" />
                  <line x1="8" y1="21" x2="16" y2="21" />
                  <line x1="12" y1="17" x2="12" y2="21" />
                </svg>
                Schedule AI Interview
              </button>
              <button class="action-menu-item" (click)="closeActionMenu()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                Download Resume
              </button>
              <button class="action-menu-item" (click)="closeActionMenu()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M12 20h9" />
                  <path
                    d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                  />
                </svg>
                Change Status
              </button>
              <div class="action-menu-divider"></div>
              <button
                class="action-menu-item action-menu-danger"
                (click)="deleteCandidate(candidate.id); closeActionMenu()"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M3 6h18" />
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                </svg>
                Delete
              </button>
            </div>-->
          <!--</td>-->
        </tr>
        </ng-container>
        <tr *ngIf="!isLoading && filteredCandidates.length === 0">
          <td colspan="18" class="empty-state-cell">
            No candidates match the selected filters.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Aligned Footer Pagination Bar -->
   <ng-container *hasPermission="[PermissionForStudents.CANDIDATE_VIEW_FRESHER,
  PermissionForStudents.CANDIDATE_VIEW_EXPERIENCED,
  PermissionForStudents.CANDIDATE_VIEW_EDUCATOR]">
  <div class="table-pagination-footer">
    <span class="showing-txt"
      >Showing {{ startIndex }}-{{ endIndex }} of {{ totalCandidates }}</span
    >
    <div class="pagination-buttons">
      <button
        class="pag-btn"
        [disabled]="!hasPreviousPage"
        (click)="previousPage()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>
      </button>
      <button class="pag-btn active-page">{{ currentPage }}</button>
      <button class="pag-btn" [disabled]="!hasNextPage" (click)="nextPage()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="m9 18 6-6-6-6" />
        </svg>
      </button>
    </div>
  </div>
  </ng-container>
</div>

<!-- ADD CANDIDATES MODAL POPUP-->
<div class="modal-backdrop-blur" *ngIf="isAddPopupOpen">
  <div class="modal-window-card fade-in-panel">
    <!-- Modal Header -->
    <div class="modal-header-row">
      <div class="modal-header-text">
        <h2 class="modal-title">
          {{ isEditMode ? "Edit Candidate" : "Add Candidates" }}
        </h2>
        <p class="modal-subtitle">
          {{
            isEditMode
              ? "Update candidate details"
              : "Add candidates manually or upload a CSV file"
          }}
        </p>
      </div>
      <button class="modal-close-icon-btn" (click)="closeAddPopup()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <!-- Experience Selection Circular Radios -->
    <div class="modal-experience-selector-row">
      <ng-container *hasPermission="PermissionForStudents.CANDIDATE_VIEW_FRESHER">
      <label class="custom-radio-option">
        <input
          type="radio"
          name="popupExperienceType"
          [(ngModel)]="popupExperienceType"
          value="fresher"
          (change)="resetForm()"
        />
        <span class="custom-radio-circle"></span>
        <span class="custom-radio-lbl">Fresher</span>
      </label>
      </ng-container>

      <ng-container *hasPermission="PermissionForStudents.CANDIDATE_VIEW_EXPERIENCED">
      <label class="custom-radio-option">
        <input
          type="radio"
          name="popupExperienceType"
          [(ngModel)]="popupExperienceType"
          value="experienced"
          (change)="resetForm()"
        />
        <span class="custom-radio-circle"></span>
        <span class="custom-radio-lbl">Experienced</span>
      </label>
      </ng-container>

      <ng-container *hasPermission="PermissionForStudents.CANDIDATE_VIEW_EDUCATOR">
      <label class="custom-radio-option">
        <input
          type="radio"
          name="popupExperienceType"
          [(ngModel)]="popupExperienceType"
          value="educator"
          (change)="resetForm()"
        />
        <span class="custom-radio-circle"></span>
        <span class="custom-radio-lbl">Candidate</span>
      </label>
      </ng-container>
    </div>

    <!-- Tab Selection Pill -->
    <div class="modal-tab-pill-bar" *ngIf="!isEditMode">
      <button
        class="tab-pill-btn"
        [class.active]="popupTab === 'Manual'"
        (click)="popupTab = 'Manual'"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="inline-pill-icon"
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <line x1="19" y1="8" x2="19" y2="14" />
          <line x1="22" y1="11" x2="16" y2="11" />
        </svg>
        Manual Entry
      </button>
      <button
        class="tab-pill-btn"
        [class.active]="popupTab === 'CSV'"
        (click)="popupTab = 'CSV'"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="inline-pill-icon"
        >
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" />
          <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
        Upload CSV
      </button>
    </div>

    <!-- ================= MANUAL ENTRY FORM ================= -->
    <div class="modal-content-scrollable-area" *ngIf="popupTab === 'Manual'">
      <!-- Fresher Manual Fields -->
      <div *ngIf="popupExperienceType === 'fresher'">
        <form [formGroup]="FresherCandidateForm" class="manual-form-grid">
          <div class="form-control">
            <span class="form-label"
              >Full Name <span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="name"
              placeholder="Enter full name"
              class="modal-input-field"
              maxlength="100"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                FresherCandidateForm.get('name')?.touched &&
                FresherCandidateForm.get('name')?.hasError('required')
              "
            >
              Name is required
            </small>
            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('name')?.dirty ||
                  FresherCandidateForm.get('name')?.touched) &&
                FresherCandidateForm.get('name')?.hasError('minLengthName')
              "
            >
              Name must be at least 2 characters long.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('name')?.dirty ||
                  FresherCandidateForm.get('name')?.touched) &&
                FresherCandidateForm.get('name')?.hasError('invalidName')
              "
            >
              Please enter a valid name. Name can contain only letters, spaces,
              apostrophes, periods and hyphens.
            </small>
            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('name')?.dirty ||
                  FresherCandidateForm.get('name')?.touched) &&
                FresherCandidateForm.get('name')?.hasError('maxLengthName')
              "
            >
              Maximum 100 characters allowed</small
            >
          </div>
          <div class="form-control">
            <span class="form-label"
              >Email <span class="asterisk">*</span></span
            >
            <input
              type="email"
              formControlName="email"
              placeholder="Enter email address"
              class="modal-input-field"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                FresherCandidateForm.get('email')?.touched &&
                FresherCandidateForm.get('email')?.hasError('required')
              "
            >
              Email is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('email')?.dirty ||
                FresherCandidateForm.get('email')?.touched) &&
                FresherCandidateForm.get('email')?.hasError('emailSpace')
              "
            >
              Email address cannot contain spaces.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('email')?.dirty ||
                FresherCandidateForm.get('email')?.touched) &&
                FresherCandidateForm.get('email')?.hasError('invalidEmail')
              "
            >
              Please enter a valid email address.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('email')?.dirty ||
                FresherCandidateForm.get('email')?.touched) &&
                FresherCandidateForm.get('email')?.hasError('maxLengthEmail')
              "
            >
              Email cannot exceed 254 characters.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label"
              >Mobile <span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="mobile"
              placeholder="Enter mobile number"
              class="modal-input-field"
              maxlength="10"
              inputmode="numeric"
              (keypress)="onlyAllowDigits($event)"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                FresherCandidateForm.get('mobile')?.touched &&
                FresherCandidateForm.get('mobile')?.hasError('required')
              "
            >
              Mobile number is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('mobile')?.dirty ||
                FresherCandidateForm.get('mobile')?.touched) &&
                !FresherCandidateForm.get('mobile')?.hasError('required') &&
                (FresherCandidateForm.get('mobile')?.hasError('pattern') ||
                  FresherCandidateForm.get('mobile')?.hasError('minlength'))
              "
            >
              Enter a valid 10-digit mobile number.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label">
              Job <span class="asterisk">*</span>
            </span>

            <div style="position: relative" (click)="$event.stopPropagation()">
              <input
                type="text"
                class="modal-input-field"
                formControlName="role"
                placeholder="Select Job"
                (focus)="onFresherJobFocus()"
                (input)="onFresherJobSearch()"
                (blur)="closeJobDropdown()"
                autocomplete="off"
              />

              <div class="autocomplete-dropdown" *ngIf="showJobDropdown">
                <div class="dropdown-body">
                  <div
                    class="autocomplete-item"
                    *ngFor="let job of allPostJobs"
                    (mousedown)="selectFresherJob(job)"
                  >
                    {{ job.job_title }}
                  </div>
                </div>

                <div class="dropdown-pagination" *ngIf="totalPage > 1">
                  <button
                    type="button"
                    (mousedown)="previousJobPage($event)"
                    [disabled]="page === 1"
                  >
                    Previous
                  </button>

                  <span>{{ page }} / {{ totalPage }}</span>

                  <button
                    type="button"
                    (mousedown)="nextJobPage($event)"
                    [disabled]="page === totalPage"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>

            <small
              class="text-danger smaller-text"
              *ngIf="
                FresherCandidateForm.get('role')?.touched &&
                FresherCandidateForm.get('role')?.hasError('required')
              "
            >
              Job is required.
            </small>
          </div>

          <div class="form-control">
            <span class="form-label"
              >Current Location <span class="asterisk">*</span></span
            >
            <div style="position: relative">
              <input
                type="text"
                formControlName="current_location"
                placeholder="Type to filter cities..."
                class="modal-input-field"
                (input)="filterCurrentLocation()"
                (focus)="onCurrentLocationFocus()"
                (blur)="closeCurrentLocationDropdown()"
              />

              <div
                class="autocomplete-dropdown"
                *ngIf="showCurrentLocationDropdown"
              >
                <div
                  class="autocomplete-item"
                  *ngFor="let city of filteredCurrentLocations"
                  (mousedown)="selectCurrentLocation(city)"
                >
                  {{ city }}
                </div>
              </div>
            </div>
            <small
              class="text-danger smaller-text"
              *ngIf="
                FresherCandidateForm.get('current_location')?.touched &&
                FresherCandidateForm.get('current_location')?.hasError(
                  'required'
                )
              "
            >
              Location is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('current_location')?.dirty ||
                FresherCandidateForm.get('current_location')?.touched) &&
                FresherCandidateForm.get('current_location')?.hasError(
                  'minLengthCity'
                )
              "
            >
              Minimum length is 2 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('current_location')?.dirty ||
                FresherCandidateForm.get('current_location')?.touched) &&
                FresherCandidateForm.get('current_location')?.hasError(
                  'maxLengthCity'
                )
              "
            >
              Maximum length is 100 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('current_location')?.dirty ||
                FresherCandidateForm.get('current_location')?.touched) &&
                FresherCandidateForm.get('current_location')?.hasError(
                  'invalidCity'
                )
              "
            >
              Only letters, spaces, hyphens (-) and periods (.) are allowed.
            </small>
          </div>

          <div class="form-control">
            <span class="form-label"
              >Education<span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="education"
              placeholder="Enter education details"
              class="modal-input-field"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                FresherCandidateForm.get('education')?.touched &&
                FresherCandidateForm.get('education')?.hasError('required')
              "
            >
              Education is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('education')?.dirty ||
                FresherCandidateForm.get('education')?.touched) &&
                (FresherCandidateForm.get('education')?.hasError(
                  'minLengthEducation'
                ) ||
                  FresherCandidateForm.get('education')?.hasError(
                    'maxLengthEducation'
                  ) ||
                  FresherCandidateForm.get('education')?.hasError(
                    'invalidEducation'
                  ))
              "
            >
              Please enter a valid education detail.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label">College Name</span>
            <input
              type="text"
              formControlName="previous_institute"
              placeholder="Enter college name"
              class="modal-input-field"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('previous_institute')?.dirty ||
                FresherCandidateForm.get('previous_institute')?.touched) &&
                FresherCandidateForm.get('previous_institute')?.hasError(
                  'maxlength'
                )
              "
            >
              College name cannot exceed 150 characters.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label">Year of Passing</span>
            <input
              type="text"
              formControlName="year_of_passing"
              placeholder="Enter year of passing"
              class="modal-input-field"
              maxlength="4"
              inputmode="numeric"
              (keypress)="onlyAllowDigits($event)"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('year_of_passing')?.dirty ||
                  FresherCandidateForm.get('year_of_passing')?.touched) &&
                FresherCandidateForm.get('year_of_passing')?.hasError(
                  'invalidYear'
                )
              "
            >
              Enter a valid 4-digit year.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('year_of_passing')?.dirty ||
                  FresherCandidateForm.get('year_of_passing')?.touched) &&
                FresherCandidateForm.get('year_of_passing')?.hasError('minYear')
              "
            >
              Year cannot be earlier than 1950.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('year_of_passing')?.dirty ||
                  FresherCandidateForm.get('year_of_passing')?.touched) &&
                FresherCandidateForm.get('year_of_passing')?.hasError(
                  'futureYear'
                )
              "
            >
              Year cannot be greater than the current year.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label">CGPA</span>
            <input
              type="text"
              formControlName="cgpa"
              placeholder="Enter CGPA"
              class="modal-input-field"
              inputmode="decimal"
              (keypress)="allowDecimalNumbers($event)"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                FresherCandidateForm.get('cgpa')?.touched &&
                FresherCandidateForm.get('cgpa')?.hasError('required')
              "
            >
              CGPA is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('cgpa')?.dirty ||
                FresherCandidateForm.get('cgpa')?.touched) &&
                FresherCandidateForm.get('cgpa')?.hasError('invalidCgpa')
              "
            >
              Please enter a valid CGPA (0.00-10.00) with up to 2 decimal places.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('cgpa')?.dirty ||
                FresherCandidateForm.get('cgpa')?.touched) &&
                FresherCandidateForm.get('cgpa')?.hasError('cgpaRange')
              "
            >
              CGPA should be between 0.00 and 10.00.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label">Skills (comma-separated)</span>
            <input
              type="text"
              formControlName="skills"
              placeholder="e.g. Java, Python, SQL"
              class="modal-input-field"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('skills')?.dirty ||
                  FresherCandidateForm.get('skills')?.touched) &&
                FresherCandidateForm.get('skills')?.hasError('minSkillLength')
              "
            >
              Each skill must be at least 2 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('skills')?.dirty ||
                  FresherCandidateForm.get('skills')?.touched) &&
                FresherCandidateForm.get('skills')?.hasError('maxSkillLength')
              "
            >
              Each skill cannot exceed 50 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('skills')?.dirty ||
                  FresherCandidateForm.get('skills')?.touched) &&
                FresherCandidateForm.get('skills')?.hasError('invalidSkills')
              "
            >
              Only letters, numbers, spaces and commas are allowed.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('skills')?.dirty ||
                  FresherCandidateForm.get('skills')?.touched) &&
                FresherCandidateForm.get('skills')?.hasError('maxSkills')
              "
            >
              Maximum 30 skills can be added.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('skills')?.dirty ||
                  FresherCandidateForm.get('skills')?.touched) &&
                FresherCandidateForm.get('skills')?.hasError('duplicateSkills')
              "
            >
              Duplicate skills are not allowed.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (FresherCandidateForm.get('skills')?.dirty ||
                  FresherCandidateForm.get('skills')?.touched) &&
                FresherCandidateForm.get('skills')?.hasError('emptySkill')
              "
            >
              Skills must be separated by commas. Empty skills are not allowed.
            </small>
          </div>
          <div class="form-control full-width">
            <span class="form-label"> Resume </span>

            <label class="file-upload-wrapper">
              <input
                type="file"
                (change)="onFileSelected($event)"
                class="file-input-hidden"
              />

              <div class="file-upload-box">
                <span class="upload-icon">📄</span>

                <div class="upload-content">
                  <span class="upload-title">
                    {{ selectedResumeFile?.name || "Choose Resume" }}
                  </span>
                  <span class="upload-subtitle"> PDF, DOC, DOCX </span>
                </div>
              </div>
            </label>
          </div>
        </form>
      </div>

      <!-- Experienced Manual Fields -->
      <div *ngIf="popupExperienceType === 'experienced'">
        <form [formGroup]="ExperiencedCandidateForm" class="manual-form-grid">
          <div class="form-control">
            <span class="form-label"
              >Full Name <span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="name"
              placeholder="Enter full name"
              class="modal-input-field"
              maxlength="100"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('name')?.touched &&
                ExperiencedCandidateForm.get('name')?.hasError('required')
              "
            >
              Name is required
            </small>
            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('name')?.dirty ||
                ExperiencedCandidateForm.get('name')?.touched) &&
                ExperiencedCandidateForm.get('name')?.hasError('minLengthName')
              "
            >
              Name must be at least 2 characters long.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('name')?.dirty ||
                ExperiencedCandidateForm.get('name')?.touched) &&
                ExperiencedCandidateForm.get('name')?.hasError('invalidName')
              "
            >
              Please enter a valid name. Name can contain only letters, spaces,
              apostrophes, periods and hyphens.
            </small>
            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('name')?.dirty || ExperiencedCandidateForm.get('name')?.touched) &&
                ExperiencedCandidateForm.get('name')?.hasError('maxLengthName')
              "
            >
              Maximum 100 characters allowed</small
            >
          </div>
          <div class="form-control">
            <span class="form-label"
              >Email <span class="asterisk">*</span></span
            >
            <input
              type="email"
              formControlName="email"
              placeholder="Enter email address"
              class="modal-input-field"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('email')?.touched &&
                ExperiencedCandidateForm.get('email')?.hasError('required')
              "
            >
              Email is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('email')?.dirty ||
                ExperiencedCandidateForm.get('email')?.touched) &&
                ExperiencedCandidateForm.get('email')?.hasError('emailSpace')
              "
            >
              Email address cannot contain spaces.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('email')?.dirty ||
                ExperiencedCandidateForm.get('email')?.touched) &&
                ExperiencedCandidateForm.get('email')?.hasError('invalidEmail')
              "
            >
              Please enter a valid email address.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('email')?.dirty ||
                ExperiencedCandidateForm.get('email')?.touched) &&
                ExperiencedCandidateForm.get('email')?.hasError(
                  'maxLengthEmail'
                )
              "
            >
              Email cannot exceed 254 characters.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label"
              >Mobile <span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="mobile"
              placeholder="Enter mobile number"
              class="modal-input-field"
              maxlength="10"
              inputmode="numeric"
              (keypress)="onlyAllowDigits($event)"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('mobile')?.touched &&
                ExperiencedCandidateForm.get('mobile')?.hasError('required')
              "
            >
              Mobile number is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('mobile')?.dirty ||
                ExperiencedCandidateForm.get('mobile')?.touched) &&
                !ExperiencedCandidateForm.get('mobile')?.hasError('required') &&
                (ExperiencedCandidateForm.get('mobile')?.hasError('pattern') ||
                  ExperiencedCandidateForm.get('mobile')?.hasError('minlength'))
              "
            >
              Enter a valid 10-digit mobile number.
            </small>
          </div>

          <div class="form-control">
            <span class="form-label">
              Job <span class="asterisk">*</span>
            </span>

            <div style="position: relative" (click)="$event.stopPropagation()">
              <input
                type="text"
                class="modal-input-field"
                formControlName="role"
                placeholder="Select Job"
                (focus)="showJobDropdown = true; page = 1; getAllJobs()"
                (input)="onJobSearch()"
                (blur)="closeJobDropdown()"
                autocomplete="off"
              />

              <div class="autocomplete-dropdown" *ngIf="showJobDropdown">
                <div class="dropdown-body">
                  <div
                    class="autocomplete-item"
                    *ngFor="let job of allPostJobs"
                    (mousedown)="selectJob(job)"
                  >
                    {{ job.job_title }}
                  </div>
                </div>

                <div class="dropdown-pagination" *ngIf="totalPage > 1">
                  <button
                    type="button"
                    (mousedown)="previousJobPage($event)"
                    [disabled]="page === 1"
                  >
                    Previous
                  </button>

                  <span>{{ page }} / {{ totalPage }}</span>

                  <button
                    type="button"
                    (mousedown)="nextJobPage($event)"
                    [disabled]="page === totalPage"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>

            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('role')?.touched &&
                ExperiencedCandidateForm.get('role')?.hasError('required')
              "
            >
              Job is required.
            </small>
          </div>

          <div class="form-control">
            <span class="form-label"
              >Current Location <span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="current_location"
              placeholder="Enter current location"
              class="modal-input-field"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('current_location')?.touched &&
                ExperiencedCandidateForm.get('current_location')?.hasError(
                  'required'
                )
              "
            >
              Location is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('current_location')?.dirty ||
                ExperiencedCandidateForm.get('current_location')?.touched) &&
                ExperiencedCandidateForm.get('current_location')?.hasError(
                  'minLengthCity'
                )
              "
            >
              Minimum length is 2 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('current_location')?.dirty ||
                ExperiencedCandidateForm.get('current_location')?.touched) &&
                ExperiencedCandidateForm.get('current_location')?.hasError(
                  'maxLengthCity'
                )
              "
            >
              Maximum length is 100 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('current_location')?.dirty ||
                ExperiencedCandidateForm.get('current_location')?.touched) &&
                ExperiencedCandidateForm.get('current_location')?.hasError(
                  'invalidCity'
                )
              "
            >
              Only letters, spaces, hyphens (-) and periods (.) are allowed.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label"
              >Education <span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="education"
              placeholder="e.g. B.Tech / B.E"
              class="modal-input-field"
              maxlength="100"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('education')?.touched &&
                ExperiencedCandidateForm.get('education')?.hasError('required')
              "
            >
              Education is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('education')?.dirty ||
                ExperiencedCandidateForm.get('education')?.touched) &&
                ExperiencedCandidateForm.get('education')?.hasError(
                  'minLengthEducation'
                )
              "
            >
              Education must be at least 2 characters long.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('education')?.dirty ||
                ExperiencedCandidateForm.get('education')?.touched) &&
                ExperiencedCandidateForm.get('education')?.hasError(
                  'maxLengthEducation'
                )
              "
            >
              Education cannot exceed 100 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('education')?.dirty ||
                ExperiencedCandidateForm.get('education')?.touched) &&
                ExperiencedCandidateForm.get('education')?.hasError(
                  'invalidEducation'
                )
              "
            >
              Only letters, spaces, hyphens (-), periods (.), and slashes (/)
              are allowed.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label">College Name</span>
            <input
              type="text"
              formControlName="previous_institute"
              placeholder="Enter college name"
              class="modal-input-field"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('previous_institute')?.dirty ||
                ExperiencedCandidateForm.get('previous_institute')?.touched) &&
                ExperiencedCandidateForm.get('previous_institute')?.hasError(
                  'maxlength'
                )
              "
            >
              College name cannot exceed 150 characters.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label">Year of Passing</span>
            <input
              type="text"
              formControlName="year_of_passing"
              placeholder="Enter year of passing"
              class="modal-input-field"
              inputmode="numeric"
              (keypress)="onlyAllowDigits($event)"
              maxlength="4"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('year_of_passing')?.dirty ||
                  ExperiencedCandidateForm.get('year_of_passing')?.touched) &&
                ExperiencedCandidateForm.get('year_of_passing')?.hasError(
                  'invalidYear')"
            >
              Enter a valid 4-digit year.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('year_of_passing')?.dirty ||
                  ExperiencedCandidateForm.get('year_of_passing')?.touched) &&
                ExperiencedCandidateForm.get('year_of_passing')?.hasError(
                  'minYear')"
            >
              Year cannot be earlier than 1950.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('year_of_passing')?.dirty ||
                  ExperiencedCandidateForm.get('year_of_passing')?.touched) &&
                ExperiencedCandidateForm.get('year_of_passing')?.hasError(
                  'futureYear')"
            >
              Year cannot be greater than the current year.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label"
              >Current / Last Job Title <span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="current_title"
              placeholder="Enter current/last job title"
              class="modal-input-field"
              maxlength="100"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('current_title')?.touched &&
                ExperiencedCandidateForm.get('current_title')?.hasError(
                  'required'
                )
              "
            >
              Job title is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('current_title')?.dirty ||
                ExperiencedCandidateForm.get('current_title')?.touched) &&
                ExperiencedCandidateForm.get('current_title')?.hasError(
                  'minLengthJobTitle'
                )
              "
            >
              Job title must be at least 2 characters long.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('current_title')?.dirty ||
                ExperiencedCandidateForm.get('current_title')?.touched) &&
                ExperiencedCandidateForm.get('current_title')?.hasError(
                  'maxLengthJobTitle'
                )
              "
            >
              Job title cannot exceed 100 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('current_title')?.dirty ||
                ExperiencedCandidateForm.get('current_title')?.touched) &&
                ExperiencedCandidateForm.get('current_title')?.hasError(
                  'invalidJobTitle'
                )
              "
            >
              Please enter a valid job title. Only letters, numbers, spaces,
              hyphens (-), periods (.), forward slashes (/), and ampersands (&)
              are allowed.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label"
              >Current / Last Company <span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="current_company"
              placeholder="Enter current/last company"
              class="modal-input-field"
              maxlength="100"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('current_company')?.touched &&
                ExperiencedCandidateForm.get('current_company')?.hasError(
                  'required'
                )
              "
            >
              Company name is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('current_company')?.dirty ||
                ExperiencedCandidateForm.get('current_company')?.touched) &&
                ExperiencedCandidateForm.get('current_company')?.hasError(
                  'minLengthCompany'
                )
              "
            >
              Company name must be at least 2 characters long.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('current_company')?.dirty ||
                ExperiencedCandidateForm.get('current_company')?.touched) &&
                ExperiencedCandidateForm.get('current_company')?.hasError(
                  'maxLengthCompany'
                )
              "
            >
              Company name cannot exceed 100 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('current_company')?.dirty ||
                ExperiencedCandidateForm.get('current_company')?.touched) &&
                ExperiencedCandidateForm.get('current_company')?.hasError(
                  'invalidCompany'
                )
              "
            >
              Please enter a valid company name. Only letters, numbers, spaces,
              hyphens (-), periods (.), forward slashes (/), and ampersands (&)
              are allowed.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label">Core Expertise</span>
            <input
              type="text"
              formControlName="core_expertise"
              placeholder="Enter core expertise"
              class="modal-input-field"
            />
          </div>
          <div class="form-control">
            <span class="form-label"
              >Total Years of Experience <span class="asterisk">*</span></span
            >
            <input
              formControlName="experience_years"
              placeholder="Enter experience in years"
              class="modal-input-field"
              minlength="1"
              maxlength="2"
              type="number"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('experience_years')?.touched &&
                ExperiencedCandidateForm.get('experience_years')?.hasError(
                  'required'
                )
              "
            >
              Total years of experience is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('experience_years')?.dirty ||
                ExperiencedCandidateForm.get('experience_years')?.touched) &&
                ExperiencedCandidateForm.get('experience_years')?.hasError(
                  'pattern'
                )
              "
            >
              Enter a valid total years of experience. Only numeric values are
              allowed, with optional decimals (e.g., 2.5).
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="ExperiencedCandidateForm.get('experience_years')?.touched &&
                (ExperiencedCandidateForm.get('experience_years')?.hasError('min') ||
                ExperiencedCandidateForm.get('experience_years')?.hasError('max'))">
              Total years of experience must be between 0 and 50 years.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label"
              >Current CTC (L)<span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="current_ctc"
              placeholder="Enter current CTC"
              class="modal-input-field"
              inputmode="decimal"
              (keypress)="allowDecimalNumbers($event)"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('current_ctc')?.touched &&
                ExperiencedCandidateForm.get('current_ctc')?.hasError(
                  'required'
                )
              "
            >
              Current CTC is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('current_ctc')?.dirty ||
                ExperiencedCandidateForm.get('current_ctc')?.touched) &&
                ExperiencedCandidateForm.get('current_ctc')?.hasError(
                  'invalidCtc'
                )
              "
            >
              Enter a valid numeric value with up to 2 decimal places.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('current_ctc')?.dirty ||
                ExperiencedCandidateForm.get('current_ctc')?.touched) &&
                ExperiencedCandidateForm.get('current_ctc')?.hasError(
                  'ctcOutOfRange'
                )
              "
            >
              Value must be between 0 and 1000 Lakhs.
            </small>
          </div>
          <div class="form-control">
            <span class="form-label"
              >Expected CTC (L)<span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="expected_ctc"
              placeholder="Enter expected CTC"
              class="modal-input-field"
              inputmode="decimal"
              (keypress)="allowDecimalNumbers($event)"
            />
            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('expected_ctc')?.touched &&
                ExperiencedCandidateForm.get('expected_ctc')?.hasError(
                  'required'
                )
              "
            >
              Expected CTC is required.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('expected_ctc')?.dirty ||
                ExperiencedCandidateForm.get('expected_ctc')?.touched) &&
                ExperiencedCandidateForm.get('expected_ctc')?.hasError(
                  'invalidCtc'
                )
              "
            >
              Enter a valid numeric value with up to 2 decimal places.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('expected_ctc')?.dirty ||
                ExperiencedCandidateForm.get('expected_ctc')?.touched) &&
                ExperiencedCandidateForm.get('expected_ctc')?.hasError(
                  'ctcOutOfRange'
                )
              "
            >
              Value must be between 0 and 1000 Lakhs.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('expected_ctc')?.dirty ||
                ExperiencedCandidateForm.get('expected_ctc')?.touched) &&
                ExperiencedCandidateForm.get('expected_ctc')?.hasError(
                  'expectedLessThanCurrent'
                )
              "
            >
              Expected CTC should be greater than or equal to Current CTC.
            </small>
          </div>

          <div class="form-control">
            <span class="form-label">Preferred City 1</span>

            <div style="position: relative">
              <input
                type="text"
                formControlName="city_pref_1"
                placeholder="Type to filter cities..."
                class="modal-input-field"
                (input)="filterExperiencedCities('city_pref_1')"
                (focus)="onExperiencedCityFocus('city_pref_1')"
                (blur)="closeExperiencedCityDropdown('city_pref_1')"
              />

              <div
                class="autocomplete-dropdown"
                *ngIf="showExperiencedCityDropdown1"
              >
                <div
                  class="autocomplete-item"
                  *ngFor="let city of filteredExperiencedCities1"
                  (mousedown)="selectExperiencedCity('city_pref_1', city)"
                >
                  {{ city }}
                </div>
              </div>
            </div>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('city_pref_1')?.dirty ||
                ExperiencedCandidateForm.get('city_pref_1')?.touched) &&
                ExperiencedCandidateForm.get('city_pref_1')?.hasError(
                  'minLengthCity'
                )
              "
            >
              Minimum length is 2 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('city_pref_1')?.dirty ||
                ExperiencedCandidateForm.get('city_pref_1')?.touched) &&
                ExperiencedCandidateForm.get('city_pref_1')?.hasError(
                  'maxLengthCity'
                )
              "
            >
              Maximum length is 100 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                (ExperiencedCandidateForm.get('city_pref_1')?.dirty ||
                  ExperiencedCandidateForm.get('city_pref_1')?.touched) &&
                ExperiencedCandidateForm.get('city_pref_1')?.hasError(
                  'invalidCity'
                )
              "
            >
              Please select a valid city from the list.
            </small>
          </div>

          <div class="form-control">
            <span class="form-label">Preferred City 2</span>

            <div style="position: relative">
              <input
                type="text"
                formControlName="city_pref_2"
                placeholder="Type to filter cities..."
                class="modal-input-field"
                (input)="filterExperiencedCities('city_pref_2')"
                (focus)="onExperiencedCityFocus('city_pref_2')"
                (blur)="closeExperiencedCityDropdown('city_pref_2')"
              />

              <div
                class="autocomplete-dropdown"
                *ngIf="showExperiencedCityDropdown2"
              >
                <div
                  class="autocomplete-item"
                  *ngFor="let city of filteredExperiencedCities2"
                  (mousedown)="selectExperiencedCity('city_pref_2', city)"
                >
                  {{ city }}
                </div>
              </div>
            </div>

            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('city_pref_2')?.touched &&
                ExperiencedCandidateForm.get('city_pref_2')?.hasError(
                  'minLengthCity'
                )
              "
            >
              Minimum length is 2 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('city_pref_2')?.touched &&
                ExperiencedCandidateForm.get('city_pref_2')?.hasError(
                  'maxLengthCity'
                )
              "
            >
              Maximum length is 100 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('city_pref_2')?.touched &&
                ExperiencedCandidateForm.get('city_pref_2')?.hasError(
                  'invalidCity'
                )
              "
            >
              Please select a valid city from the list.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('city_pref_2')?.touched &&
                ExperiencedCandidateForm.get('city_pref_2')?.hasError(
                  'duplicateCity'
                )
              "
            >
              Preferred City 2 cannot be the same as Preferred City 1.
            </small>
          </div>

          <div class="form-control">
            <span class="form-label">Preferred City 3</span>

            <div style="position: relative">
              <input
                type="text"
                formControlName="city_pref_3"
                placeholder="Type to filter cities..."
                class="modal-input-field"
                (input)="filterExperiencedCities('city_pref_3')"
                (focus)="onExperiencedCityFocus('city_pref_3')"
                (blur)="closeExperiencedCityDropdown('city_pref_3')"
              />

              <div
                class="autocomplete-dropdown"
                *ngIf="showExperiencedCityDropdown3"
              >
                <div
                  class="autocomplete-item"
                  *ngFor="let city of filteredExperiencedCities3"
                  (mousedown)="selectExperiencedCity('city_pref_3', city)"
                >
                  {{ city }}
                </div>
              </div>
            </div>

            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('city_pref_3')?.touched &&
                ExperiencedCandidateForm.get('city_pref_3')?.hasError(
                  'minLengthCity'
                )
              "
            >
              Minimum length is 2 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('city_pref_3')?.touched &&
                ExperiencedCandidateForm.get('city_pref_3')?.hasError(
                  'maxLengthCity'
                )
              "
            >
              Maximum length is 100 characters.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('city_pref_3')?.touched &&
                ExperiencedCandidateForm.get('city_pref_3')?.hasError(
                  'invalidCity'
                )
              "
            >
              Please select a valid city from the list.
            </small>

            <small
              class="text-danger smaller-text"
              *ngIf="
                ExperiencedCandidateForm.get('city_pref_3')?.touched &&
                ExperiencedCandidateForm.get('city_pref_3')?.hasError(
                  'duplicateCity'
                )
              "
            >
              Preferred City 3 cannot be the same as Preferred City 1 or
              Preferred City 2.
            </small>
          </div>

          <div class="form-control full-width">
            <span class="form-label"> Resume </span>

            <label class="file-upload-wrapper">
              <input
                type="file"
                (change)="onFileSelected($event)"
                class="file-input-hidden"
              />

              <div class="file-upload-box">
                <span class="upload-icon">📄</span>

                <div class="upload-content">
                  <span class="upload-title">
                    {{ selectedResumeFile?.name || "Choose Resume" }}
                  </span>
                  <span class="upload-subtitle"> PDF, DOC, DOCX </span>
                </div>
              </div>
            </label>
          </div>
        </form>
      </div>

      <!-- Educator Manual Fields -->
      <div *ngIf="popupExperienceType === 'educator'">
        <form [formGroup]="EducatorCandidateForm" class="manual-form-grid">
          <div class="form-control">
            <span class="form-label"
              >Full Name <span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="name"
              placeholder="Enter full name"
              class="modal-input-field"
              (keypress)="blockNumberKeys($event)"
              [class.input-error]="
                EducatorCandidateForm.controls['name'].invalid &&
                EducatorCandidateForm.controls['name'].touched
              "
            />
            <div
              *ngIf="
                EducatorCandidateForm.controls['name'].touched &&
                EducatorCandidateForm.controls['name'].invalid
              "
              class="error-message"
            >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['name'].errors?.['required']
                "
                >Name is required.</small
              >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['name'].errors?.[
                    'minLengthError'
                  ]
                "
                >Name must be at least 2 characters long.</small
              >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['name'].errors?.[
                    'maxLengthError'
                  ]
                "
                >Name must not exceed 100 characters.</small
              >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['name'].errors?.[
                    'invalidFormat'
                  ]
                "
                >Name can contain only letters and spaces.</small
              >
            </div>
          </div>
          <div class="form-control">
            <span class="form-label"
              >Email <span class="asterisk">*</span></span
            >
            <input
              type="email"
              formControlName="email"
              placeholder="Enter email address"
              class="modal-input-field"
              [class.input-error]="
                EducatorCandidateForm.controls['email'].invalid &&
                EducatorCandidateForm.controls['email'].touched
              "
            />
            <div
              *ngIf="
                EducatorCandidateForm.controls['email'].touched &&
                EducatorCandidateForm.controls['email'].invalid
              "
              class="error-message"
            >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['email'].errors?.['required']
                "
                >Email is required.</small
              >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['email'].errors?.['hasSpaces']
                "
                >Email address cannot contain spaces.</small
              >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['email'].errors?.[
                    'invalidEmail'
                  ] ||
                  EducatorCandidateForm.controls['email'].errors?.[
                    'maxLengthError'
                  ]
                "
                >Please enter a valid email address (maximum 255
                characters).</small
              >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['email'].errors?.[
                    'emailExists'
                  ]
                "
                >This email is already associated with another candidate.</small
              >
            </div>
          </div>

          <div class="form-control">
            <span class="form-label"
              >Mobile <span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="mobile"
              placeholder="Enter mobile number"
              class="modal-input-field"
              maxlength="10"
              (keypress)="onlyAllowDigits($event)"
              [class.input-error]="
                EducatorCandidateForm.controls['mobile'].invalid &&
                EducatorCandidateForm.controls['mobile'].touched
              "
            />
            <div
              *ngIf="
                EducatorCandidateForm.controls['mobile'].touched &&
                EducatorCandidateForm.controls['mobile'].invalid
              "
              class="error-message"
            >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['mobile'].errors?.['required']
                "
                >Mobile number is required.</small
              >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['mobile'].errors?.[
                    'invalidPhone'
                  ]
                "
                >Please enter a valid 10-digit mobile number.</small
              >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['mobile'].errors?.[
                    'mobileExists'
                  ]
                "
                >This mobile number is already associated with another
                candidate.</small
              >
            </div>
          </div>

          <div class="form-control">
            <span class="form-label"
              >Subject <span class="asterisk">*</span></span
            >
            <input
              type="text"
              formControlName="subject"
              placeholder="Enter subject"
              class="modal-input-field"
              (keypress)="blockNumberKeys($event)"
              [class.input-error]="
                EducatorCandidateForm.controls['subject'].invalid &&
                EducatorCandidateForm.controls['subject'].touched
              "
            />
            <div
              *ngIf="
                EducatorCandidateForm.controls['subject'].touched &&
                EducatorCandidateForm.controls['subject'].invalid
              "
              class="error-message"
            >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['subject'].errors?.['required']
                "
                >Subject is required.</small
              >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['subject'].errors?.[
                    'invalidLength'
                  ]
                "
                >Subject name must be between 2 and 150 characters.</small
              >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['subject'].errors?.[
                    'invalidFormat'
                  ]
                "
                >Subject can only contain letters, spaces, -, &, and ().</small
              >
            </div>
          </div>

          <div class="form-control">
            <span class="form-label">Goal</span>
            <input
              type="text"
              formControlName="subject_specialization"
              placeholder="Enter specialization"
              class="modal-input-field"
              (keypress)="blockNumberKeys($event)"
              [class.input-error]="
                EducatorCandidateForm.controls['subject_specialization']
                  .invalid &&
                EducatorCandidateForm.controls['subject_specialization'].touched
              "
            />
            <div
              *ngIf="
                EducatorCandidateForm.controls['subject_specialization']
                  .touched &&
                EducatorCandidateForm.controls['subject_specialization'].invalid
              "
              class="error-message"
            >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['subject_specialization']
                    .errors?.['required']
                "
                >Specialization is required.</small
              >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['subject_specialization']
                    .errors?.['invalidLength']
                "
                >Specialization must be between 2 and 100 characters.</small
              >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['subject_specialization']
                    .errors?.['invalidFormat']
                "
                >Specialization can only contain letters, spaces, and
                punctuation.</small
              >
            </div>
          </div>
          <div class="form-control">
            <span class="form-label">Years of Experience</span>
            <input
              type="text"
              formControlName="experience_years"
              placeholder="Enter experience in years"
              class="modal-input-field"
              (input)="restrictExperienceInput($event)"
              [class.input-error]="
                EducatorCandidateForm.controls['experience_years'].invalid &&
                EducatorCandidateForm.controls['experience_years'].touched
              "
            />
            <div
              *ngIf="
                EducatorCandidateForm.controls['experience_years'].touched &&
                EducatorCandidateForm.controls['experience_years'].invalid
              "
              class="error-message"
            >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['experience_years'].errors?.[
                    'invalidExperience'
                  ]
                "
                >Experience must be between 0 and 50 years (up to 2 decimal
                places).</small
              >
            </div>
          </div>

          <div class="form-control">
            <span class="form-label">Current CTC (L) </span>
            <input
              type="text"
              formControlName="current_ctc"
              placeholder="Enter current CTC"
              class="modal-input-field"
              (input)="restrictCtcInput($event, 'current_ctc')"
              [class.input-error]="
                EducatorCandidateForm.controls['current_ctc'].invalid &&
                EducatorCandidateForm.controls['current_ctc'].touched
              "
            />
            <div
              *ngIf="
                EducatorCandidateForm.controls['current_ctc'].touched &&
                EducatorCandidateForm.controls['current_ctc'].invalid
              "
              class="error-message"
            >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['current_ctc'].errors?.[
                    'invalidCTC'
                  ]
                "
                >Current CTC must be a positive number (up to 2 decimal
                places).</small
              >
            </div>
          </div>

          <div class="form-control">
            <span class="form-label">Expected CTC (L) </span>
            <input
              type="text"
              formControlName="expected_ctc"
              placeholder="Enter expected CTC"
              class="modal-input-field"
              (input)="restrictCtcInput($event, 'expected_ctc')"
              [class.input-error]="
                EducatorCandidateForm.controls['expected_ctc'].invalid &&
                EducatorCandidateForm.controls['expected_ctc'].touched
              "
            />
            <div
              *ngIf="
                EducatorCandidateForm.controls['expected_ctc'].touched &&
                EducatorCandidateForm.controls['expected_ctc'].invalid
              "
              class="error-message"
            >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['expected_ctc'].errors?.[
                    'invalidCTC'
                  ]
                "
                >Expected CTC must be a positive number (up to 2 decimal
                places).</small
              >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['expected_ctc'].errors?.[
                    'ctcLessThanCurrent'
                  ]
                "
                >Expected CTC must be greater than or equal to Current
                CTC.</small
              >
            </div>
          </div>
          <div class="form-control">
            <span class="form-label">Previous Institute</span>
            <input
              type="text"
              formControlName="previous_institute"
              placeholder="Enter previous institute"
              class="modal-input-field"
              [class.input-error]="
                EducatorCandidateForm.controls['previous_institute'].invalid &&
                EducatorCandidateForm.controls['previous_institute'].touched
              "
            />
            <div
              *ngIf="
                EducatorCandidateForm.controls['previous_institute'].touched &&
                EducatorCandidateForm.controls['previous_institute'].invalid
              "
              class="error-message"
            >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['previous_institute'].errors?.[
                    'invalidLength'
                  ]
                "
                >Institute name must not exceed 150 characters.</small
              >
            </div>
          </div>
          <div class="form-control">
            <span class="form-label">City 1st Preference</span>
            <div style="position: relative">
              <input
                type="text"
                formControlName="city_pref_1"
                placeholder="Type to filter cities..."
                class="modal-input-field"
                (input)="filterCities('city_pref_1')"
                (focus)="onCityFocus('city_pref_1')"
                (blur)="closeCityDropdown('city_pref_1')"
                [class.input-error]="
                  (EducatorCandidateForm.controls['city_pref_1'].invalid ||
                    EducatorCandidateForm.hasError('duplicateCities')) &&
                  EducatorCandidateForm.controls['city_pref_1'].touched
                "
              />
              <div class="autocomplete-dropdown" *ngIf="showCityDropdown1">
                <div
                  class="autocomplete-item"
                  *ngFor="let city of filteredCities1"
                  (mousedown)="selectCity('city_pref_1', city)"
                >
                  {{ city }}
                </div>
              </div>
            </div>
            <div
              *ngIf="
                EducatorCandidateForm.controls['city_pref_1'].touched &&
                (EducatorCandidateForm.controls['city_pref_1'].invalid ||
                  EducatorCandidateForm.hasError('duplicateCities'))
              "
              class="error-message"
            >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['city_pref_1'].errors?.[
                    'invalidCity'
                  ]
                "
                >Please select a valid city from the list.</small
              >
              <small *ngIf="EducatorCandidateForm.hasError('duplicateCities')"
                >Preferred cities must be unique.</small
              >
            </div>
          </div>
          <div class="form-control">
            <span class="form-label">City 2nd Preference</span>
            <div style="position: relative">
              <input
                type="text"
                formControlName="city_pref_2"
                placeholder="Type to filter cities..."
                class="modal-input-field"
                (input)="filterCities('city_pref_2')"
                (focus)="onCityFocus('city_pref_2')"
                (blur)="closeCityDropdown('city_pref_2')"
                [class.input-error]="
                  (EducatorCandidateForm.controls['city_pref_2'].invalid ||
                    EducatorCandidateForm.hasError('duplicateCities')) &&
                  EducatorCandidateForm.controls['city_pref_2'].touched
                "
              />
              <div class="autocomplete-dropdown" *ngIf="showCityDropdown2">
                <div
                  class="autocomplete-item"
                  *ngFor="let city of filteredCities2"
                  (mousedown)="selectCity('city_pref_2', city)"
                >
                  {{ city }}
                </div>
              </div>
            </div>
            <div
              *ngIf="
                EducatorCandidateForm.controls['city_pref_2'].touched &&
                (EducatorCandidateForm.controls['city_pref_2'].invalid ||
                  EducatorCandidateForm.hasError('duplicateCities'))
              "
              class="error-message"
            >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['city_pref_2'].errors?.[
                    'invalidCity'
                  ]
                "
                >Please select a valid city from the list.</small
              >
              <small *ngIf="EducatorCandidateForm.hasError('duplicateCities')"
                >Preferred cities must be unique.</small
              >
            </div>
          </div>
          <div class="form-control">
            <span class="form-label">City 3rd Preference</span>
            <div style="position: relative">
              <input
                type="text"
                formControlName="city_pref_3"
                placeholder="Type to filter cities..."
                class="modal-input-field"
                (input)="filterCities('city_pref_3')"
                (focus)="onCityFocus('city_pref_3')"
                (blur)="closeCityDropdown('city_pref_3')"
                [class.input-error]="
                  (EducatorCandidateForm.controls['city_pref_3'].invalid ||
                    EducatorCandidateForm.hasError('duplicateCities')) &&
                  EducatorCandidateForm.controls['city_pref_3'].touched
                "
              />
              <div class="autocomplete-dropdown" *ngIf="showCityDropdown3">
                <div
                  class="autocomplete-item"
                  *ngFor="let city of filteredCities3"
                  (mousedown)="selectCity('city_pref_3', city)"
                >
                  {{ city }}
                </div>
              </div>
            </div>
            <div
              *ngIf="
                EducatorCandidateForm.controls['city_pref_3'].touched &&
                (EducatorCandidateForm.controls['city_pref_3'].invalid ||
                  EducatorCandidateForm.hasError('duplicateCities'))
              "
              class="error-message"
            >
              <small
                *ngIf="
                  EducatorCandidateForm.controls['city_pref_3'].errors?.[
                    'invalidCity'
                  ]
                "
                >Please select a valid city from the list.</small
              >
              <small *ngIf="EducatorCandidateForm.hasError('duplicateCities')"
                >Preferred cities must be unique.</small
              >
            </div>
          </div>

          <div class="form-control full-width">
            <span class="form-label"> Resume </span>

            <label class="file-upload-wrapper">
              <input
                type="file"
                (change)="onFileSelected($event)"
                class="file-input-hidden"
              />

              <div class="file-upload-box">
                <span class="upload-icon">📄</span>

                <div class="upload-content">
                  <span class="upload-title">
                    {{ selectedResumeFile?.name || "Choose Resume" }}
                  </span>
                  <span class="upload-subtitle"> PDF, DOC, DOCX </span>
                </div>
              </div>
            </label>
          </div>
        </form>
      </div>
    </div>

    <!-- ================= UPLOAD CSV VIEW ================= -->
    <div class="modal-content-scrollable-area" *ngIf="popupTab === 'CSV'">
      <div class="csv-upload-section">
        <div class="csv-columns-info-row">
          <span
            class="csv-helper-txt"
            *ngIf="popupExperienceType === 'fresher'"
          >
            Expected columns:
            <span class="mono-columns"
              >name, email, mobile, role, location, education, college_name,
              year_of_passing_out, cgpa, skills</span
            >
          </span>
          <span
            class="csv-helper-txt"
            *ngIf="popupExperienceType === 'experienced'"
          >
            Expected columns:
            <span class="mono-columns"
              >name, email, mobile, role, location, education, college_name,
              year_of_passing_out, current_title, current_company,
              core_expertise, experience, current_ctc, expected_ctc, pref_city1,
              pref_city2, pref_city3</span
            >
          </span>
          <span
            class="csv-helper-txt"
            *ngIf="popupExperienceType === 'educator'"
          >
            Expected columns:
            <span class="mono-columns"
              >name, email, mobile, subject, goal, experience, currentCTC,
              expectedCTC, previousInstitute, prefCity1, prefCity2,
              prefCity3</span
            >
          </span>
          <button class="btn-template-download" (click)="downloadTemplate()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="template-down-icon"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Template
          </button>
        </div>

        <input
          #csvInput
          type="file"
          accept=".csv"
          style="display: none"
          (change)="onCsvFileSelected($event)"
        />
        <div class="csv-drag-drop-zone" (click)="importCSV()">
          <div class="cloud-upload-icon-wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="cloud-icon"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
          </div>
          <span class="drag-drop-title">{{
            isSubmitting ? "Uploading..." : "Click to upload CSV"
          }}</span>
          <span class="drag-drop-subtitle"
            >.csv file with the columns listed above</span
          >
        </div>
        <div class="csv-result-message" *ngIf="importResultMessage">
          {{ importResultMessage }}
        </div>
      </div>
    </div>

    <!-- Modal Footer Actions -->
    <div class="modal-footer-row" *ngIf="popupTab === 'Manual'">
      <button class="btn-modal-cancel" (click)="closeAddPopup()">Cancel</button>
      <button
        class="btn-modal-submit"
        (click)="saveCandidate()"
        [disabled]="isSubmitting"
      >
        {{
          isSubmitting
            ? "Saving..."
            : isEditMode
              ? "Update Candidate"
              : "Add Candidate"
        }}
      </button>
    </div>
    <div class="modal-footer-row" *ngIf="popupTab === 'CSV'">
      <button class="btn-modal-cancel" (click)="closeAddPopup()">Close</button>
      <!-- <button class="btn-modal-submit btn-csv-import" (click)="importCSV()">Import</button> -->
    </div>
  </div>
</div>

<div
  class="status-modal-overlay"
  *ngIf="showDeleteConfirmPopup"
  (click)="cancelDelete()"
>
  <div class="status-modal-box fade-up" (click)="$event.stopPropagation()">
    <h2 class="status-modal-heading">
      Delete Candidate
    </h2>
    <p class="status-modal-body">
      Are you sure you want to delete this candidate? 
      This action cannot be undone.
     </p>
    <div class="status-modal-actions">
      <button class="status-btn-cancel" (click)="cancelDelete()">Cancel</button>
      <button
        class="status-btn-confirm"
        (click)="deleteCandidate(selectedCandidateId!)"
        [disabled]="isCandidateDelete"
      >
        <span
          *ngIf="isCandidateDelete"
          class="spinner-border spinner-border-sm me-1"
        ></span>
        {{ isCandidateDelete ? "Deleting..." : "Delete" }}
      </button>
    </div>
  </div>
</div>